const PREFIX = 'PARTNER_SERVICE_';

const setValue = (key, val) => {
    return sessionStorage.setItem(PREFIX + key, JSON.stringify(val));
};

const getValue = (key) => {
    return JSON.parse(sessionStorage.getItem(PREFIX + key));
};

/**
 * @param partner {string}
 * @param flag {boolean}
 */
const setPartnerValue = (partner, flag) => {
    if (flag === false && !getValue(partner)) {
        return false;
    }

    setValue(partner, flag);
    return true;
};

export default {
    /**
     * @param partner {string}
     *
     * @returns {boolean}
     */
    setPartnerFlow(partner) {
        return setPartnerValue(partner, true);
    },

    /**
     * @param partner {string}
     *
     * @returns {boolean}
     */
    unsetPartnerFlow(partner) {
        return setPartnerValue(partner, false);
    },

    /**
     * @param partner {String}
     *
     * return {Boolean}
     */
    isPartnerFlow(partner) {
        return !!getValue(partner);
    }
};
